import { CREATE_BENEFIT_GROUP_API_TAG } from '@epi-constants/benefitGroups';

export const BENEFICIARY_TAGS = [
  'beneficiaryDetails',
  'companyBeneficiariesList'
];

export const USER_TAGS = ['userDetails'];
export const BENEFIT_GROUPS = [CREATE_BENEFIT_GROUP_API_TAG];

export const ALL_API_TAGS = [
  ...USER_TAGS,
  ...BENEFICIARY_TAGS,
  ...BENEFIT_GROUPS
] as const;
